import { View } from "react-native";
import { useTailwind } from "tailwind-rn";

import Multientrega from "../../../../../logos/Multientrega";
import CardText from "../../CardText";

type Props = {
  carrier: string;
};

export function FulfillmentMethod({ carrier }: Props) {
  const tailwind = useTailwind();

  return (
    <View style={tailwind("flex-1 flex-row items-center justify-end")}>
      {carrier === "Multientrega" ? <Multientrega /> : null}
      <CardText.Label style={tailwind("ml-1 text-right")} text={carrier} />
    </View>
  );
}
